export default function Navbar() {
  return (
    <nav className="nav">
      <div className="nav__inner">
        <div className="nav__brand">
          <a href="#" className="nav__logo">Monika Chaudhary</a>
          <span className="nav__role">SDET · 9 years</span>
        </div>
        <ul className="nav__links">
          <li><a href="#experience">Experience</a></li>
          <li><a href="#tools">Tools</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}
